import React, { useContext, useEffect, useState } from "react";
import { Profile } from "../../components";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import AppContext from "../../AppContext";
import { useSearchParams } from "react-router-dom";

const CompanyProfile = ({ companyId, edit }) => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();

  if (!id && !companyId) return "NotFound";

  const navigate = useNavigate();

  const handleEditProfile = () => {
    navigate("/companies/edit");
  };

  const handleNewProject = () => {
    navigate("/new-project");
  };

  return (
    <Profile
      id={companyId || id}
      isCompany={true}
      onEdit={handleEditProfile}
      onNewProject={handleNewProject}
      viewMode={searchParams.get("view")}
      edit={edit}
    />
  );
};

const CompanyPage = () => {
  const { user } = useContext(AppContext);

  return (
    <Routes>
      <Route path="" element={<CompanyProfile companyId={user?.company} />} />
      <Route
        path="edit"
        element={<CompanyProfile companyId={user?.company} edit />}
      />
      <Route path=":id" element={<CompanyProfile />} />
    </Routes>
  );
};

CompanyPage.propTypes = {};

export default CompanyPage;
